export default __webpack_public_path__ + "static/national-metric-mobile-98f51d2608a49729346a281017012371.svg";